'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  color: _react.PropTypes.string,
  pill: _react.PropTypes.bool,
  tag: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]),
  children: _react.PropTypes.node,
  className: _react.PropTypes.any
};

var defaultProps = {
  color: 'default',
  pill: false,
  tag: 'span'
};

var Tag = function Tag(props) {
  var className = props.className;
  var color = props.color;
  var pill = props.pill;
  var Component = props.tag;

  var attributes = _objectWithoutProperties(props, ['className', 'color', 'pill', 'tag']);

  var classes = (0, _classnames2.default)(className, 'tag', 'tag-' + color, pill ? 'tag-pill' : false);

  return _react2.default.createElement(Component, _extends({}, attributes, { className: classes }));
};

Tag.propTypes = propTypes;
Tag.defaultProps = defaultProps;

exports.default = Tag;


/*****************
 ** WEBPACK FOOTER
 ** ./~/reactstrap/lib/Tag.js
 ** module id = 199
 ** module chunks = 0
 **/